import Vue from 'vue'
import Router from 'vue-router'
import Help from '@/views/Help.vue'
import store from '../../store'
import LoginPage from '@/views/LoginPage.vue'
import NotificationBreakdown from "../../views/NotificationBreakdown";
import MultiPlots from "../../views/MultiPlots";
import EquipmentPlots from "../../views/EquipmentPlots";
import Fault from "../../views/Fault";
import AnomalySummaryView from "../../views/AnomalySummaryView";
import Equipments from "../../views/Equipments";
import Facility from "../../views/Facility";
import Points from "../../views/Points";
import Config from "../../views/Config";
import Parameter from "../../views/Parameter";
import AnomalyDescription from "../../views/AnomalyDescription";
import MaintenanceRecord from "../../views/MaintenanceRecord";
import ViewData from "../../views/ViewData";
import Rules from "../../views/Rules";
import Report from "../../views/Report";
import Settings from "../../views/Settings";
import UserAutomated from "../../views/UserAutomated";
import FaultAnalysis from "../../views/FaultAnalysis";
import FaultComparisson from "../../views/FaultComparisson";
import EquipmentSummary from "../../views/EquipmentSummary";
import Job from "../../views/Job";
import Model from "../../views/Model";
import EquipmentServicingSchedule from "../../views/EquipmentServicingSchedule";
import FaultsReport from "../../views/FaultsReport";
import CustomViewRenderer from "../../views/CustomViewRenderer";
import CustomViews from "../../views/CustomViews";
import CustomViewBuilder from "../../views/CustomViewBuilder";
import Notifications2 from "../../views/Notifications2";
import MenuConfig from "../../views/MenuConfig";
import Dates from "../../views/Dates";
import Users from "../../views/Users";
import Connectors from "../../views/Connectors";
import Builder from "../../views/Builder";
import PointMapper from "../../views/PointMapper";
import Setup from "@/views/Setup";
import AutomatedDebug from "@/views/AutomatedDebug";
import OptimizationControls from "@/views/OptimizationControls";

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL_OVERRIDE&&process.env.VUE_APP_BASE_URL_OVERRIDE!=="" ? process.env.VUE_APP_BASE_URL_OVERRIDE : process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Setup
    },
    {
      path: '/overview',
      name: 'overview',
      component: Setup
    },
    {
      path: '/help',
      name: 'help',
      component: Help
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
      meta: { public: true }
    },
    {
      path: '/notification-breakdown',
      name: 'notification-breakdown',
      component: NotificationBreakdown
    },
    {
      path: '/users',
      name: 'users',
      component: Users
    },
    {
      path: '/multiplots',
      name: 'multiplots',
      component: MultiPlots
    },{
      path: '/equipment-plots',
      name: 'equipment-plots',
      component: EquipmentPlots
    },
    {
      path: '/dates',
      name: 'dates',
      component: Dates
    },
    {
      path: '/fault',
      name: 'fault',
      component: Fault
    },{
      path: '/menu-config',
      name: 'menu-config',
      component: MenuConfig
    },
    {
      path: '/faults-report',
      name: 'faults-report',
      component: FaultsReport
    },
    {
      path: '/modelsummary',
      name: 'modelsummary',
      component: AnomalySummaryView
    },
    {
      path: '/equipments',
      name: 'equipments',
      component: Equipments
    },
    {
      path: '/facility',
      name: 'facility',
      component: Facility
    },
    {
      path: '/points',
      name: 'points',
      component: Points
    },
    {
      path: '/config',
      name: 'config',
      component: Config
    },
    {
      path: '/parameter',
      name: 'parameter',
      component: Parameter
    },
    {
      path: '/anomaly-description',
      name: 'anomaly-description',
      component: AnomalyDescription
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings
    },
    {
      path: '/report',
      name: 'report',
      component: Report
    },
    {
      path: '/rules',
      name: 'rules',
      component: Rules
    },
    {
      path: '/viewdata',
      name: 'viewdata',
      component: ViewData
    },
    {
      path: '/maintenancerecord',
      name: 'maintenancerecord',
      component: MaintenanceRecord
    },
    {
      path: '/user-automated/:id',
      name: 'user-automated',
      component: UserAutomated
    },
    {
      path: '/fault-analysis',
      name: 'faultAnalysis',
      component: FaultAnalysis
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: Notifications2
    },
    {
      path: '/fault-comparison',
      name: 'fault-comparison',
      component: FaultComparisson
    },
    {
      path: '/equipment-summary',
      name: 'equipment-summary',
      component: EquipmentSummary
    },{
      path: '/equipment-servicing-schedule',
      name: 'equipment-servicing-schedule',
      component: EquipmentServicingSchedule
    },
    {
      path: '/job',
      name: 'job',
      component: Job
    },
    {
      path: '/model',
      name: 'model',
      component: Model
    },
    {
      path: '/custom-view/:id',
      name: 'custom-view',
      component: CustomViewRenderer
    },
    {
      path: '/custom-view-builder',
      name: 'custom-view-builder',
      component: CustomViewBuilder
    },
    {
      path: '/custom-views',
      name: 'custom-views',
      component: CustomViews
    },
    {
      path: '/connectors',
      name: 'connectors',
      component: Connectors
    },
    {
      path: '/builder',
      name: 'builder',
      component: Builder
    },
    {
      path: '/point-mapper',
      name: 'point-mapper',
      component: PointMapper
    },
    {
      path: '/setup',
      name: 'setup',
      component: Setup
    },
    {
      path: '/automated-debug',
      name: 'automated-debug',
      component: AutomatedDebug
    },
    {
      path: '/optimization-controls',
      name: 'optimization-controls',
      component: OptimizationControls
    }
  ]
})

router.beforeEach((to, from, next) => {


  if (to.matched.some(r => r.meta.guest) && store.state.userStore.user) {
    next({ name: 'home' })
    return
  }
  next()
})

export default router
